import { useQuery } from '@ltvco/refresh-lib/vendors';

import { useBaseCourtApi } from './useBaseCourtApi';

const DOCKET_ENTRIES_QUERY_OPTIONS = {
  retry: 3,
  retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000),
  staleTime: 2 * 60 * 1000,
  cacheTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export const usePartiesAttorneysData = (docketId: string) => {
  const {
    getAllAttorneys,
    getAllParties,
    isLoading: isTokenLoading,
  } = useBaseCourtApi();

  const attorneysQuery = useQuery<any[]>(
    ['all-attorneys', docketId],
    () => getAllAttorneys(docketId),
    {
      ...DOCKET_ENTRIES_QUERY_OPTIONS,
      enabled: !!docketId && !isTokenLoading,
    }
  );

  const partiesQuery = useQuery<any[]>(
    ['all-parties', docketId],
    () => getAllParties(docketId),
    {
      ...DOCKET_ENTRIES_QUERY_OPTIONS,
      enabled: !!docketId && !isTokenLoading,
    }
  );

  const isLoading =
    attorneysQuery.isLoading || partiesQuery.isLoading || isTokenLoading;
  const hasError = attorneysQuery.isError || partiesQuery.isError;
  const error = attorneysQuery.error || partiesQuery.error;
  const attorneysData = attorneysQuery.data || [];
  const partiesData = partiesQuery.data || [];

  return {
    attorneysData,
    partiesData,
    isLoading,
    hasError,
    error,
    partiesCount: partiesData.length,
    attorneysCount: attorneysData.length,
  };
};
